export default "__VITE_PUBLIC_ASSET__211bc69b__"